module.exports = __webpack_public_path__ + "static/hf3-12-7f808572ea7761ca1c72063750a4874a.gif";